import './Call.css';
import React, { useEffect, useState, useCallback, useRef } from 'react';
import DataModel from '../Util/DataModel';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { topMessageAtom, isAuthAtom } from '../../State';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import isElectron from '../../Global';
import Header from '../Header/Header';
import ShowMessage from '../Header/ShowMessage';
import AuthCheck from '../../AuthCheck';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { ReactComponent as LogoTextSVG } from '../Images/header/smilelogotext.svg';

export default function Feedback() {
  const textAreaRef = useRef(null);
  const [isSent, setIsSent] = useState(false);
  const [authState, setAuthState] = useRecoilState(isAuthAtom);
  const setTopMessageState = useSetRecoilState(topMessageAtom);
  const navigate = useNavigate(); //リダイレクト用

  //ルートから
  const location = useLocation();
  const [comefromExitState, setComeFromExitState] = useState(location.state);
  const { t } = useTranslation();

  // useEffect(() => {
  //   //参加成功のお知らせ
  //   setTopMessageState({
  //     type: 'joined',
  //     message: 'Left call',
  //   });
  // }, []);

  //Exitから来た場合のみ表示（リロードやダイレクトアクセスの場合は動作しない）
  useEffect(() => {
    if (comefromExitState != null && comefromExitState.comeFromExit) {
      setTopMessageState({
        type: 'joined',
        message: t('top.Left the call'),
      });

      //履歴を書き換えて再度表示されないように
      window.history.replaceState(null, '', window.location.href);
      window.history.pushState(null, '', window.location.href);
    }
  }, [comefromExitState]);

  const exitCall = async () => {
    if (isElectron) {
      window.myapi.leaveMeeting();
    } else {
      //navigate('/');
      if (authState) {
        window.location.href = 'https://faceless.ooo/app';
      } else {
        window.location.href = 'https://faceless.ooo';
      }
    }
  };

  const onTapSend = async () => {
    if (textAreaRef.current.value != '') {
      setIsSent(true);

      //2秒後に終了
      setTimeout(() => {
        //exitCall();

        if (isElectron) {
          window.myapi.leaveMeeting();
        } else {
          //navigate('/');
          window.location.href = 'https://faceless.ooo';
        }
      }, 2000);

      //DBに保存
      const result = await DataModel.sendFeedback(textAreaRef.current.value);
    }
  };

  return (
    <>
      <ShowMessage />
      <AuthCheck />
      <div id="feedbackBack">
        {/*　ヘッダー */}
        <div id="browserHeader">
          <div id="browserHeaderLogoText" onClick={exitCall}>
            <LogoTextSVG />
            {/* <img src="https://d2wp3sepl8g4xv.cloudfront.net/hp/images/logo.png" alt="Photo" /> */}
          </div>
          <div className="menu-area">
            <ul>
              {/* <li>
                <a href="https://faceless.ooo/collab">Collaboration</a>
              </li> */}
              {/* <li>
                <a href="https://faceless.ooo/about">About us</a>
              </li> */}

              {/* {isMobile == false && (
                <li>
                  <a href="https://faceless.ooo/faq">FAQ</a>
                </li>
              )} */}

              {/* <li className="important">
                <a href="https://faceless.ooo/access">Get a pass</a>
              </li> */}
            </ul>
          </div>
        </div>
        <div id="feedbackWrap">
          <div id="feedbackRelative">
            <h1>{t('setting.Feedback')}</h1>
            <h2>
              {t('setting.Please give us...')}
              <a target="_blank" href="https://faceless.ooo/contact">
                {t('setting.contact us')}
              </a>
              {t('setting.form')}
            </h2>
            {isSent == false ? (
              <>
                <textarea
                  ref={textAreaRef}
                  placeholder={t('setting.Type your feedback here')}></textarea>

                <div id="feedbackButtonArea">
                  <button id="feedbackCloseButton" onClick={exitCall}>
                    {t('setting.Close')}
                  </button>
                  <div></div>
                  <button id="feedbackSendButton" onClick={onTapSend}>
                    {t('setting.Send')}
                  </button>
                </div>
              </>
            ) : (
              <div id="feedbackThankyou">{t('setting.Thank you!')}</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
